module.exports = __webpack_public_path__ + "public/assets/img/bg2.06b9201d.png";